<template>
  <div id="centreLeft1">
    <div class="bg-color-black">
      <div class="d-flex pt-2 pl-2">
        <span style="color: #5cd9e8">
          <i class="iconfont iconcaigouleixingzhanbi"></i>
        </span>
        <div class="d-flex">
          <span class="fs-xl text mx-2">今日交易占比</span>
          <dv-decoration-1
            style="
              width: 1.25rem;
              height: 0.25rem;
              position: relative;
              top: -0.0375rem;
            "
          />
        </div>
      </div>
      <div class="d-flex jc-center">
        <!-- <CentreLeft2Chart /> -->
        <Echart
          :options="options"
          id="centreLeft1Chart"
          height="3.7rem"
          width="5.2rem"
        ></Echart>
      </div>
    </div>
  </div>
</template>

<script>
// import CentreLeft2Chart from "@/components/echart/centerLeft/centerLeft2Chart";
import { mapState } from "vuex";
import Echart from "@/common/echart";
export default {
  data() {
    return {
      options: {},
      trafficWay: [],
      twoInterval: "",
    };
  },
  components: {
    Echart,
  },
  mounted() {
    this.submitGetMessageList();
  },
  methods: {
    dataList() {
      var data = [];
      var color = [
        "#00ffff",
        "#00cfff",
        "#ee5e7b",
        "#ffe000",
        "#ffa800",
        "#ff5b00",
        "#ff3000",
      ];
      var trafficWay = this.trafficWay;
      for (var i = 0; i < trafficWay.length; i++) {
        data.push(
          {
            value: trafficWay[i].value,
            name: trafficWay[i].name,
            itemStyle: {
              normal: {
                borderWidth: 2,
                shadowBlur: 10,
                borderColor: color[i],
                shadowColor: color[i],
              },
            },
          },
          {
            value: 2,
            name: "",
            itemStyle: {
              normal: {
                label: {
                  show: false,
                },
                labelLine: {
                  show: false,
                },
                color: "rgba(0, 0, 0, 0)",
                borderWidth: 0,
              },
            },
          }
        );
      }
      var seriesOption = [
        {
          name: "",
          type: "pie",
          clockWise: false,
          radius: "50%",
          hoverAnimation: true,
          itemStyle: {
            normal: {
              label: {
                show: true,
                formatter: function (params) {
                  var percent = 0;
                  var total = 0;
                  for (var i = 0; i < trafficWay.length; i++) {
                    total += trafficWay[i].value;
                  }
                  percent = ((params.value / total) * 100).toFixed(0);
                  if (params.name !== "") {
                    return params.name + "\n" + "\n" + "￥" + params.value;
                  } else {
                    return "";
                  }
                },
              },
            },
          },
          data: data,
        },
      ];
      var list = {
        color: color,
        title: {
          top: "50%",
          textAlign: "center",
          left: "39%",
          textStyle: {
            color: "#fff",
            fontSize: 22,
            fontWeight: "400",
          },
        },
        tooltip: {
          show: false,
        },
        toolbox: {
          show: false,
        },
        series: seriesOption,
      };
      this.options = list;
    },
    submitGetMessageList() {
      const that = this;
      that.$store.dispatch("getMessageList", 2); //$dispatch在vue2中已废除，此处用的是elementUI中的方法，触发actions
      that.twoInterval = setInterval(() => {
        that.$store.dispatch("getMessageList", 2); //$dispatch在vue2中已废除，此处用的是elementUI中的方法，触发actions
      }, 5000);
    },
  },
  beforeDestroy () {
    clearInterval(this.twoInterval);
    this.twoInterval = null;
  },
  watch: {
    // watch 可以监听 data 数据 也可以监听 全局 vuex数据
    //监听vuex中reailTimeToal的变化
    "$store.state.reailTimeToal"(val) {
      //变化之后根据自己项目需求写自身的逻辑代码，下面只是示例
      let data = [];
      if (val.tempCash > 0) {
        data.push({ name: "临时车现金", value: val.tempCash.toFixed(1) });
      }
      if (val.tempEpay > 0) {
        data.push({ name: "临时车电子支付", value: val.tempEpay.toFixed(1) });
      }
      if (val.monthCash > 0) {
        data.push({ name: "月租车现金", value: val.monthCash.toFixed(1) });
      }
      if (val.monthEpay > 0) {
        data.push({ name: "月租车电子支付", value: val.monthEpay.toFixed(1) });
      }
      if (val.storeCash > 0) {
        data.push({ name: "储值车现金", value: val.storeCash.toFixed(1) });
      }
      if (val.storeEpay > 0) {
        data.push({ name: "储值车电子支付", value: val.storeEpay.toFixed(1) });
      }
      // if (val.discountCash > 0) {
      //   data.push({ name: "优惠卷现金", value: val.discountCash.toFixed(1) });
      // }
      // if (val.discountEpay > 0) {
      //   data.push({ name: "优惠卷电子支付", value: val.discountEpay.toFixed(1) });
      // }
      this.trafficWay = data;
      this.dataList();
    },
  },
};
</script>

<style lang="scss" scoped>
#centreLeft1 {
  // padding: 0.1rem;
  height: 100%;
  min-width: 3.75rem;
  border-radius: 0.0625rem;
  .bg-color-black {
    height: 4.8125rem;
    border-radius: 0.125rem;

    .iconfont {
      font-size: 0.25rem;
    }
  }
  .text {
    color: #c3cbde;
  }
  .chart-box {
    margin-top: 0.2rem;
    width: 2.125rem;
    height: 2.125rem;
    .active-ring-name {
      padding-top: 0.125rem;
    }
  }
}
</style>